import { apiClient } from "helpers/api_helper";

export const GetBirthdayAndAnniversaryCustomersByMonth = async (data:object) => {
    try {
        const response = await apiClient.get(`/api/v1/Customer/GetBirthdayAndAnniversaryCustomersByMonth`, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};